import { createContext } from 'react';
import { ICategoryPositionItemV2 } from 'types';

export type TChangeCategoryPositionSelectedRestaurant = { id: string; name: string };
export type TTypeOfChangeCategoryPositionModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSave'
	| 'success'
	| 'error';

export interface IChangeCategoryPositionState {
	IDSelectedCustomer: Nullable<string>;
	selectedRestaurant: Nullable<TChangeCategoryPositionSelectedRestaurant>;
	positionsData: ICategoryPositionItemV2[];
	typeOfModalWindow: TTypeOfChangeCategoryPositionModalWindow;
	isVisibleAdditionalRestaurantsModal: boolean;
	isApplyToOne: boolean;
	selectedAdditionalRestaurants: TChangeCategoryPositionSelectedRestaurant[];
	selectSearchString: string;
}

export const changeCategoryPositionInitialState: IChangeCategoryPositionState = {
	IDSelectedCustomer: null,
	selectedRestaurant: null,
	positionsData: [],
	typeOfModalWindow: null,
	isVisibleAdditionalRestaurantsModal: false,
	isApplyToOne: false,
	selectedAdditionalRestaurants: [],
	selectSearchString: '',
};

export interface IChangeCategoryPositionContext extends IChangeCategoryPositionState {
	setIDCustomer(value: Nullable<string>): void;
	setRestaurant(value: Nullable<TChangeCategoryPositionSelectedRestaurant>): void;
	resetSelectedControls(): void;
	setPositionsData(data: ICategoryPositionItemV2[]): void;
	changeTypeOfModalWindow(value: TTypeOfChangeCategoryPositionModalWindow): void;
	setVisibleAdditionalRestaurantsModal(value: boolean): void;
	toggleApplyToOne(): void;
	setAdditionalRestaurants(value: TChangeCategoryPositionSelectedRestaurant[]): void;
	changeSelectSearchString(value: string): void;
}

export const ChangeCategoryPositionContext = createContext<IChangeCategoryPositionContext>({
	setIDCustomer: () => undefined,
	setRestaurant: () => undefined,
	resetSelectedControls: () => undefined,
	setPositionsData: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setVisibleAdditionalRestaurantsModal: () => undefined,
	toggleApplyToOne: () => undefined,
	setAdditionalRestaurants: () => undefined,
	changeSelectSearchString: () => undefined,
	...changeCategoryPositionInitialState,
});
